import { jsonSchema } from "@redotech/redo-automations-model/graph/automation";
import * as z from "zod";
import { diagnosticSchema } from "./common";

/**
 * Starts one run of an automation's published version with a given trigger
 * event, through normal dispatch (entry conditions, frequency cap). Works
 * whether or not the automation is turned on. Retrying with the same
 * `requestId` finds the same run; one is generated when omitted. It's part
 * of the run's workflow id, hence the cap.
 */
export const runNow = {
  name: "runNow" as const,
  input: z.object({
    automationId: z.string(),
    payload: jsonSchema,
    requestId: z.string().min(1).max(200).optional(),
  }),
  output: z.discriminatedUnion("ok", [
    z.object({
      ok: z.literal(true),
      requestId: z.string(),
      /** The run, or null when the trigger's filter dropped the event. */
      runId: z.string().nullable(),
      outcome: z.enum([
        "invalid",
        "empty",
        "filtered",
        "rejected",
        "finished",
        "started",
        "existing",
      ]),
      /** Why a run was rejected or invalid. */
      reason: z.string().nullable(),
      /** The run's status, for a finished or existing run. */
      status: z.string().nullable(),
    }),
    /** The event doesn't match the trigger's payload type. */
    z.object({ ok: z.literal(false), diagnostics: z.array(diagnosticSchema) }),
  ]),
};
